module.exports = "<div *ngIf=\"!modalType\" >\n  <p>\n    Seçilen öneriyi silmek sitediğinize emin misiniz?\n  </p>\n\n  <button mat-raised-button color=\"warn\" style=\"float: right\" (click)=\"onNoClick()\">Sil</button>\n</div>\n\n<div *ngIf=\"modalType\">\n  <p>\n    Kullanıcıya e-posta gönder.\n  </p>\n\n  <button mat-raised-button color=\"warn\" style=\"float: right\" (click)=\"sendEmail()\">Gönder</button>\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/main/content/suggestions/dialog/dialog.component.html
// module id = ../../../../../src/app/main/content/suggestions/dialog/dialog.component.html
// module chunks = main